module.exports = __webpack_public_path__ + "img/ser-img4.7e859f88.png";